module.exports = __webpack_public_path__ + "img/logo12.bc2e624.jpg";